(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7616],{

/***/ 29051:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(98535);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var modules_Login_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73194);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33892);



var useCachedIdentifier = function(form) {
    var mounted = (0,hooks__WEBPACK_IMPORTED_MODULE_1__/* .useMounted */ .s4)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (mounted) {
            var ref;
            form.setValues({
                identifier: (ref = sessionStorage.getItem(modules_Login_constants__WEBPACK_IMPORTED_MODULE_2__/* .LOGIN_IDENTIFIER */ .B)) !== null && ref !== void 0 ? ref : ""
            });
        }
    }, [
        mounted
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useCachedIdentifier);


/***/ }),

/***/ 17406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Im": function() { return /* binding */ XM_SITE_PENDING_APPLY_TPL_UNSUPPORTED_BANNER; },
/* harmony export */   "VM": function() { return /* binding */ XM_SITE_PENDING_PRODUCT_CODE; },
/* harmony export */   "hl": function() { return /* binding */ XM_SITE_PENDING_APPLY_TPL_CODE; }
/* harmony export */ });
var XM_SITE_PENDING_APPLY_TPL_CODE = "hx_site_pending_apply_template_code";
var XM_SITE_PENDING_APPLY_TPL_UNSUPPORTED_BANNER = "hx_site_pending_apply_template_unsupported_banner";
var XM_SITE_PENDING_PRODUCT_CODE = "hx_site_pending_product_code";


/***/ }),

/***/ 94523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ initAndCleanUpLoginData; }
/* harmony export */ });
/* harmony import */ var service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90309);
/* harmony import */ var modules_Login_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73194);
/* harmony import */ var utils_cookieUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44259);



function initAndCleanUpLoginData(token, userId) {
    service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setSystemToken */ .Z.setSystemToken(token);
    service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setUid */ .Z.setUid(userId);
    sessionStorage.removeItem(modules_Login_constants__WEBPACK_IMPORTED_MODULE_2__/* .LOGIN_IDENTIFIER */ .B);
    (0,utils_cookieUtils__WEBPACK_IMPORTED_MODULE_1__/* .removeUserSourceTrackingCookies */ .jW)();
}


/***/ }),

/***/ 73194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LOGIN_IDENTIFIER; }
/* harmony export */ });
var LOGIN_IDENTIFIER = "hx_login_identifier";


/***/ }),

/***/ 33624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var next_translate_Trans__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65895);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29718);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95660);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68711);






var Footer = function(param) {
    var _align = param.align, align = _align === void 0 ? "center" : _align;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
        size: "sm",
        align: align,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            i18nKey: "user:signupHasAccount",
            components: {
                component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_3__/* .AnchorLink */ .PN, {
                    href: config_constants__WEBPACK_IMPORTED_MODULE_4__/* .Login */ .m3
                })
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 98535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ signup; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Flex/Flex.js + 1 modules
var Flex = __webpack_require__(26385);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Center/Center.js + 1 modules
var Center = __webpack_require__(91004);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(17192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.6.0/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(33481);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(65895);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/utils/index.ts + 8 modules
var utils = __webpack_require__(73046);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/FormProvider/FormProvider.js
var FormProvider = __webpack_require__(33313);
;// CONCATENATED MODULE: ./src/modules/Signup/formContext.ts


var ref = (0,_sliced_to_array/* default */.Z)((0,FormProvider/* createFormContext */.W)(), 3);
var SignupFormProvider = ref[0], useSignupFormContext = ref[1], useSignupForm = ref[2];

// EXTERNAL MODULE: ./src/components/business/index.ts + 206 modules
var business = __webpack_require__(91404);
// EXTERNAL MODULE: ./src/utils/cookieUtils.ts
var cookieUtils = __webpack_require__(44259);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Anchor/Anchor.js + 1 modules
var Anchor = __webpack_require__(98558);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-click-outside/use-click-outside.js
var use_click_outside = __webpack_require__(81533);
;// CONCATENATED MODULE: ./src/modules/Signup/components/Agreement.tsx












var Agreement = function(_param, ref) {
    var size = _param.size, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "size"
    ]);
    var t = (0,useTranslation/* default */.Z)("pageSignup").t;
    var form = useSignupFormContext();
    var _$ref = (0,react.useState)(false), tooltipOpened = _$ref[0], setTooltipOpened = _$ref[1];
    var checkBoxRef = (0,use_click_outside/* useClickOutside */.O)(function() {
        return setTooltipOpened(false);
    });
    var agreed = form.values.agreement;
    (0,react.useEffect)(function() {
        agreed && setTooltipOpened(false);
    }, [
        agreed
    ]);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            setTooltipOpened: setTooltipOpened
        };
    });
    var AgreementLabel = /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
        i18nKey: "pageSignup:agreement.title",
        components: {
            terms: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                mx: 4,
                size: size,
                href: constants/* Terms */.Fe,
                target: "_blank"
            }),
            privacy: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                mx: 4,
                size: size,
                href: constants/* Privacy */.PJ,
                target: "_blank"
            })
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* CheckBoxWithTooltip */.Ay, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: checkBoxRef
    }, rest), {
        tooltipLabel: t("pageSignup:agreement.tooltip"),
        tooltipOpened: tooltipOpened,
        label: AgreementLabel
    }), form.getInputProps("agreement", {
        type: "checkbox"
    })));
};
/* harmony default export */ var components_Agreement = (/*#__PURE__*/(0,react.forwardRef)(Agreement));

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(70563);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/PasswordInput/PasswordInput.js + 2 modules
var PasswordInput = __webpack_require__(13337);
;// CONCATENATED MODULE: ./src/modules/Signup/Form/PasswordInput.tsx








var PasswordInput_PasswordInput = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var form = useSignupFormContext();
    var t = (0,useTranslation/* default */.Z)("user").t;
    var _ref = form.getInputProps("password"), onBlur = _ref.onBlur, passwordProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "onBlur"
    ]);
    var handlePasswordChange = function(event) {
        onBlur(event);
        form.isDirty("confirmPassword") && form.values.confirmPassword && form.validateField("confirmPassword");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordInput/* PasswordInput */.W, (0,_object_spread/* default */.Z)({
        size: "md",
        placeholder: t("authentication.form.passwordInput.password"),
        autoComplete: "new-password",
        onBlur: handlePasswordChange
    }, passwordProps));
};
/* harmony default export */ var Form_PasswordInput = (PasswordInput_PasswordInput);

// EXTERNAL MODULE: ./src/modules/Login/constants.ts
var Login_constants = __webpack_require__(73194);
// EXTERNAL MODULE: ./src/modules/Login/actionsAfterLogin.ts
var actionsAfterLogin = __webpack_require__(94523);
// EXTERNAL MODULE: ./src/components/business/hooks/useCachedIdentifier.ts
var useCachedIdentifier = __webpack_require__(90706);
;// CONCATENATED MODULE: ./src/modules/Signup/Form/index.tsx





















var SignupForm = function() {
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* default */.Z)("pageSignup").t;
    var signupFormValidate = (0,business/* useFormValidations */.$5)().signupFormValidate;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useSignupMutation */.BlB)(), 2), signupMutation = ref[0], ref1 = ref[1], submitting = ref1.loading;
    var agreementRef = (0,react.useRef)(null);
    var form = useSignupForm({
        initialValues: {
            identifier: "",
            password: "",
            confirmPassword: "",
            captcha: "",
            agreement: false,
            accountName: t("form.defaultAccountName")
        },
        validateInputOnBlur: [
            "identifier"
        ],
        validate: function(values) {
            return signupFormValidate(values, form);
        }
    });
    (0,useCachedIdentifier/* default */.Z)(form);
    var handleSignup = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var identifier, password, captcha, accountName, agreement, ref, data, _signUpUser, token, user, err, graphQLErrors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        identifier = values.identifier, password = values.password, captcha = values.captcha, accountName = values.accountName, agreement = values.agreement;
                        if (!agreement) {
                            ;
                            return [
                                2,
                                (ref = agreementRef.current) === null || ref === void 0 ? void 0 : ref.setTooltipOpened(true)
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            signupMutation({
                                variables: {
                                    input: {
                                        identifier: identifier.trim(),
                                        password: password,
                                        captcha: captcha,
                                        accountName: accountName.trim(),
                                        adSource: (0,cookieUtils/* getHxUtmSource */.wW)(),
                                        adWord: (0,cookieUtils/* getHxUtmMedium */.Vw)(),
                                        referer: (0,cookieUtils/* getHxAccountReferer */.SM)()
                                    }
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (!(data === null || data === void 0 ? void 0 : data.signUpUser)) return [
                            3,
                            4
                        ];
                        _signUpUser = data.signUpUser, token = _signUpUser.token, user = _signUpUser.user;
                        (0,actionsAfterLogin/* initAndCleanUpLoginData */.d)(token, user === null || user === void 0 ? void 0 : user.id);
                        return [
                            4,
                            router.replace(constants/* AccountComplete */.wx)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        err = _state.sent();
                        graphQLErrors = err.graphQLErrors;
                        handleErrors(graphQLErrors);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSignup(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var identifierExistedErrorHandler = function() {
        var identifier = form.values.identifier;
        var message = /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
            i18nKey: "pageSignup:errors.identifierExisted",
            components: {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                    href: constants/* Login */.m3
                })
            }
        });
        form.setFieldError("identifier", message);
        sessionStorage.setItem(Login_constants/* LOGIN_IDENTIFIER */.B, identifier);
    };
    var handleErrors = function(graphQLErrors) {
        var ref, ref1;
        var errorCode = graphQLErrors === null || graphQLErrors === void 0 ? void 0 : (ref = graphQLErrors[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.extensions) === null || ref1 === void 0 ? void 0 : ref1.code;
        if (errorCode == "error.code_conflict") {
            identifierExistedErrorHandler();
        } else {
            (0,utils/* graphqlErrorCatch */.Qf)({
                graphQLErrors: graphQLErrors,
                mapping: new Map([
                    [
                        "error.mismatched",
                        t("user:authentication.form.errors.captchaMismatched")
                    ]
                ]),
                defaultMessage: t("errors.default")
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupFormProvider, {
        form: form,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            onSubmit: form.onSubmit(handleSignup),
            className: "h-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                spacing: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        order: 2,
                        children: t("desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                        spacing: "xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* IdentifierInput */.Ud, {
                                size: "md",
                                required: true,
                                formContext: form
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* CaptchaCodeSendAndInput */.wk, {
                                captchaType: domain/* CaptchaType.SignUp */.$IZ.SignUp,
                                form: form,
                                identifierExistedErrorHandler: identifierExistedErrorHandler
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_PasswordInput, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                size: "md",
                                fullWidth: true,
                                loading: submitting,
                                disabled: !form.values.identifier || !form.isValid("identifier") || !form.values.password || !form.values.captcha,
                                type: "submit",
                                children: t("form.submit")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Agreement, {
                                ref: agreementRef
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Form = (SignupForm);

// EXTERNAL MODULE: ./src/hooks/index.ts + 8 modules
var hooks = __webpack_require__(33892);
// EXTERNAL MODULE: ./src/modules/Signup/Form/Footer.tsx
var Footer = __webpack_require__(33624);
// EXTERNAL MODULE: ./src/components/site/index.ts + 21 modules
var site = __webpack_require__(24613);
// EXTERNAL MODULE: ./src/config/constants/sessionStorage.ts
var constants_sessionStorage = __webpack_require__(17406);
;// CONCATENATED MODULE: ./src/hooks/useLoginActionStorage.ts




function useLoginActionStorage() {
    var router = (0,next_router.useRouter)();
    var _query = router.query, templateCode = _query.templateCode, productCode = _query.productCode;
    (0,react.useEffect)(function() {
        if (!!templateCode) {
            (0,cookieUtils/* write */.cW)({
                name: constants_sessionStorage/* XM_SITE_PENDING_APPLY_TPL_CODE */.hl,
                value: templateCode,
                domain: ".howxm.com"
            });
        }
        if (!!productCode) {
            (0,cookieUtils/* write */.cW)({
                name: constants_sessionStorage/* XM_SITE_PENDING_PRODUCT_CODE */.VM,
                value: productCode,
                domain: ".howxm.com"
            });
        }
    }, [
        templateCode,
        productCode
    ]);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/head.js
var head = __webpack_require__(89935);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/signup.tsx










var Signup = function(param) {
    var referer = param.referer;
    (0,hooks/* useAccountSourceTrack */.j3)(referer);
    useLoginActionStorage();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        className: "h-full",
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                className: "flex-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* SessionPaper */.vD, {
                    noBorder: true,
                    minHeight: 0,
                    height: "auto",
                    p: 40,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
Signup.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(site/* SessionLayout */.bY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "注册 - 浩客HowXm官网 - 数字化系统必备的应用内调研、评价、通知工具，支持免费试用"
                })
            }),
            page
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var signup = (Signup);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2525,3703,8329,1958,4476,7094,1404,3226,9774,2888,179], function() { return __webpack_exec__(29051); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);